import React from 'react';
import styles from './paulosnesi_.module.scss';
import BackgroundLinks from './src/background-links.png';
import BannerGrupoVip from './src/1.png';
import BannerShopee from './src/2.png';
import BannerTiktokShop from './src/3.png';
import InstagramIcon from '../../icons/instagramIcon.tsx';
import TiktokIcon from '../../icons/tiktokIcon.tsx';
import WhatsappIcon from '../../icons/whatsappIcon.tsx';

const WHATSAPP_NUMBER = '5547988046604';
const WHATSAPP_MSG = 'Olá! Vim pelo link na bio e gostaria de mais informações.';
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MSG)}`;
const INSTAGRAM_URL = 'https://www.instagram.com/paulosnesi_';
const TIKTOK_URL = 'https://www.tiktok.com/@paulorecomendaoficial?_r=1&_t=ZS-99x0JqbkZIA';
const GRUPO_VIP_URL = 'https://chat.whatsapp.com/CinjPktkaftFH9fzPWWrGj?mode=gi_t';
const VITRINE_SHOPEE_URL = 'https://collshp.com/paulonesi604?view=storefront';
const VITRINE_TIKTOK_URL = 'https://vt.tiktok.com/ZSbLT59Tx/?page=TikTokShop';
const ICON_COLOR = '#ffffff';

const banners = [
    { image: BannerGrupoVip, link: GRUPO_VIP_URL, alt: 'Grupo VIP — Caçador de Ofertas' },
    { image: BannerTiktokShop, link: VITRINE_TIKTOK_URL, alt: 'Vitrine TikTok Shop' },
    { image: BannerShopee, link: VITRINE_SHOPEE_URL, alt: 'Vitrine Shopee' },
];

const Paulosnesi_: React.FC = () => {
    return (
        <div className={styles.paulosnesi_}>
            <div className={styles.main}>
                <img
                    className={styles.cardImage}
                    src={BackgroundLinks}
                    alt="Paulo Nesi — estratégias digitais que vendem"
                    decoding="async"
                />
                <div className={styles.content}>
                    <div className={styles.socialRow}>
                        <a
                            href={WHATSAPP_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.socialLink}
                            aria-label="WhatsApp"
                        >
                            <WhatsappIcon height="26" color={ICON_COLOR} />
                        </a>
                        <a
                            href={INSTAGRAM_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.socialLink}
                            aria-label="Instagram"
                        >
                            <InstagramIcon height="22" color={ICON_COLOR} />
                        </a>
                        <a
                            href={TIKTOK_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.socialLink}
                            aria-label="TikTok"
                        >
                            <TiktokIcon height="22" color={ICON_COLOR} />
                        </a>
                    </div>
                    <section className={styles.bio} aria-label="Sobre Paulo Nesi">
                        <p className={styles.bioEyebrow}>Sobre</p>
                        <p className={styles.bioLead}>
                            Sou Paulo Sérgio Nesi, pai, empreendedor e creator, movido por negócios,
                            vendas e oportunidades.
                        </p>
                        <div className={styles.bioStat}>
                            <strong>+ R$ 8 milhões</strong>
                            <span>em vendas para marcas parceiras no TikTok Shop</span>
                        </div>
                        <p className={styles.bioText}>
                            Transformei conteúdo em um negócio. Hoje uno estratégia, influência e
                            performance para conectar produtos às pessoas e transformar atenção em
                            resultado.
                        </p>
                    </section>
                    {banners.map((banner) => (
                        <a
                            key={banner.alt}
                            href={banner.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={styles.contentLink}
                        >
                            <img
                                className={styles.contentImage}
                                src={banner.image}
                                alt={banner.alt}
                                decoding="async"
                            />
                        </a>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Paulosnesi_;
